import React from 'react'
// import {currencySymbolsEnum} from '../kp-11Link-utility/kp11-utility'
import {isOneTimeItem} from '../kp-11Link-utility/kp11-utility'
import {formatPrice} from '../../../../utils/currency-format'

// Plans radio inputs
export const PlanRadioInput = ({
  checked,
  onChange,
  item,
  currency,
  customFields,
  disabled,
  billingType = 'Billed Monthly',
  country,
}) => {
  const formattedLabel = text =>
    text
      ?.replace(/marketing center/gi, '')
      .replace(/growth package/gi, '')
      .replace(/thryv leads/gi, 'Proposal Amount')
      .replace(/seo/gi, 'Proposal Amount')
      .trim() || ''
  const isSEO = item?.code === 'seobase-5-thryv-m2m' ? true : false
  const isThryvLeads =
    item?.code === 'tl-mc-5-thryv-m2m' ||
    item?.code === 'tl-tax-5-thryv-m2m' ||
    item?.code === 'tl-5-thryv-m2m'
  const targetCurrency = currency || item?.currency || 'USD'

  const getAmountWithCurrencySymbol = (
    prices,
    customFields,
    currency = 'USD',
  ) => {
    const price = prices?.find(p => p.currency === currency)
    if (!price) return null
    // const symbol = currencySymbolsEnum[currency] || ''

    if (isSEO) {
      // return `${symbol}${price.unitAmount * customFields?.alphaAmount}`
      return formatPrice(
        price.unitAmount * customFields?.alphaAmount,
        1,
        '',
        country,
      )
    }
    if (isThryvLeads) {
      // return `${symbol}${price.unitAmount * customFields?.thryvLeadAmount}`
      return formatPrice(
        price.unitAmount * customFields?.thryvLeadAmount,
        1,
        '',
        country,
      )
    }
    // return `${symbol}${price.unitAmount}`
    return formatPrice(price.unitAmount, 1, '', country)
  }

  return (
    <div
      className={`card-plan-item ${disabled ? 'disabled' : ''} 
      ${checked && !disabled ? 'checked' : ''}`}
      onClick={() => !disabled && onChange()}
    >
      <div className="radio-btn">
        {(isSEO || isThryvLeads) && (
          <input
            type="radio"
            checked={checked}
            disabled={disabled}
            onClick={onChange}
          />
        )}
        {!isSEO && !isThryvLeads && (
          <input
            type="radio"
            checked={checked}
            disabled={disabled}
            onChange={onChange}
          />
        )}
      </div>
      <div className="item-content-wrap">
        <div className="plan-item-radio-label">
          {formattedLabel(item?.name)}
        </div>
        <div className="plan-item-price">
          {getAmountWithCurrencySymbol(
            item?.currencies,
            customFields,
            targetCurrency,
          )}
        </div>
        {!isOneTimeItem(item?.code) && (
          <div className="plan-item-subtext">{billingType}</div>
        )}
      </div>
    </div>
  )
}
